import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-jaloma',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './jaloma.component.html',
  styleUrl: './jaloma.component.scss'
})
export class JalomaComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.jaloma;
}
